import * as React from 'react';
import { useTranslations } from '../../../common/translation';
import { Button } from '../../../components/button/Button';
import translations from '../translations';
import { PromoBanner } from './PromoBanner';
import {
  StyledPBContentHeader,
  StyledPBContentLink,
  StyledPBContentSubtitle,
  StyledPBContentSupertitle,
  StyledPBContentText,
  StyledPBContentTitle,
} from './PromoBanner.styles';

const websiteUrl = 'https://www.harrypotterstore.com';
const logoSrc = '/assets/experiences/shop/harry-potter-ny-logo.png';

export const HarryPotterNYBanner = () => {
  const { t } = useTranslations(translations);

  return (
    <PromoBanner
      backgroundSrc='/assets/experiences/shop/harry-potter-ny-banner.png'
      imageAlt='Harry Potter New York'
      imageSrc={logoSrc}
      invertColors={true}
      testId='harry-potter-ny-banner'
    >
      <StyledPBContentHeader>
        <StyledPBContentLink href={websiteUrl} target='_blank'>
          <StyledPBContentSupertitle>
            {t('harryPotterNYSupertitle', 'Experience the Wizarding World at')}
          </StyledPBContentSupertitle>
          <StyledPBContentTitle>{t('harryPotterNYTitle', 'Harry Potter New York')}</StyledPBContentTitle>
          <StyledPBContentSubtitle>{t('harryPotterNYSubtitle', '935 Broadway, NYC')}</StyledPBContentSubtitle>
        </StyledPBContentLink>
      </StyledPBContentHeader>
      <StyledPBContentText>
        {t(
          'harryPotterNYText',
          // tslint:disable-next-line:max-line-length
          'The largest collection of Harry Potter and Fantastic Beasts merchandise under one roof.',
        )}
      </StyledPBContentText>
      <Button disableCaps={true} href={websiteUrl} invertColors={true} target='_blank'>
        {t('harryPotterNYButtonText', 'Shop Online Now')}
      </Button>
    </PromoBanner>
  );
};
